import {
  Avatar,
  Button,
  Chip,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Grid from "@mui/material/Grid2";
import { Box, Stack } from "@mui/system";
import {
  formatDate,
  getTemplateType,
} from "../../../../../utils/ForcasterUtils";
import { useDispatch, useSelector } from "react-redux";
import DataStatusAlert from "../../../Health/DataAccuracy/UI_HelpersOf_DataAccuracy/DataStatusAlert_Helpers";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CheckPermissions } from "../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import {
  selectUserData,
  selectUserWebsitePermissions,
} from "../../../../../features/userSlice";
import {
  setSelectedDuplicateForecast,
  setSelectedMetaSharedUid,
} from "../../../../../features/forecastersSlice";

const ForeCasterInfoBase = ({ selectedForecaster }: any) => {
  const [searchParams] = useSearchParams();
  const websitePermissions = useSelector(selectUserWebsitePermissions) as any;
  const selectedSite = searchParams.get("selectedSite") as any;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const response = useSelector(selectUserData);
  const hasCreateForcastersPermission = CheckPermissions(
    response?.data?.products?.assets,
    "overview",
    "create_forecasters",
  );

  const handleClickOnDuplicate = () => {
    const updatedParams = new URLSearchParams(location.search);

    const metaSharedUid = updatedParams.get("metaSharedUid") as any;

    dispatch(setSelectedDuplicateForecast(selectedForecaster));
    dispatch(setSelectedMetaSharedUid(metaSharedUid));

    navigate(
      `/business_leader/forecaster/DuplicateForecast?${updatedParams.toString()}`,
    );
  };

  const siteName = websitePermissions.find(
    (site: any) => Object.keys(site)[0] === selectedSite,
  )?.[selectedSite]?.ui_site_name;

  return (
    <Paper sx={{ padding: "16px", borderRadius: 0 }} elevation={0}>
      <Grid container alignItems="center" mb={2}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Stack direction="row" alignItems="center" gap={2} flexWrap="wrap">
            {/* LEFT SECTION */}
            <Stack direction="row" alignItems="center" gap={2}>
              <Typography variant="h5" fontWeight={400}>
                Forecast Info {"Vr."} {selectedForecaster?.version}{" "}
                {getTemplateType(selectedForecaster?.template_type)} focused
              </Typography>

              <Box>
                <DataStatusAlert status={selectedForecaster?.status ?? "N/A"} />
              </Box>
            </Stack>

            {/* MIDDLE SECTION (Site Name) */}
            {siteName && (
              <Chip
                label={siteName}
                size="small"
                sx={{
                  fontWeight: 400,
                  fontSize: 13,
                  height: 28,
                  backgroundColor: "#7B1FA2",
                  color: "#ffffff",
                }}
              />
            )}

            {/* RIGHT SECTION */}
            <Stack direction="row" alignItems="center" gap={2}>
              {/* Created By */}
              <Stack direction="row" alignItems="center" gap={1}>
                <Typography fontWeight={500} variant="subtitle2">
                  Created By:
                </Typography>
                <Stack direction="row" alignItems="center" gap={0.5}>
                  <Avatar
                    sx={{ width: 24, height: 24 }}
                    src="#"
                    alt={selectedForecaster?.created_by}
                  />
                  <Typography fontSize={14}>
                    {selectedForecaster?.created_by}
                  </Typography>
                </Stack>
              </Stack>

              {/* Created On */}
              <Stack direction="row" alignItems="center" gap={1}>
                <Typography fontWeight={500} variant="subtitle2">
                  Created on:
                </Typography>
                <Typography fontWeight={400} variant="subtitle2">
                  {formatDate(selectedForecaster?.created)}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
          {hasCreateForcastersPermission ? (
            <Button
              variant="text"
              color="secondary"
              endIcon={<ContentCopyIcon />}
              data-tracker="127"
              onClick={handleClickOnDuplicate}
            >
              Duplicate This Version
            </Button>
          ) : (
            <Button
              disabled
              variant="text"
              color="secondary"
              data-tracker="127"
              endIcon={<ContentCopyIcon />}
            >
              Duplicate This Version
            </Button>
          )}
        </Box>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {selectedForecaster?.notes || " "}
        </Typography>
      </Grid>
      <Grid
        container
        alignItems="center"
        spacing={2}
        sx={{ whiteSpace: "nowrap" }}
        mt={1}
        justifyContent="space-between"
      >
        <Grid size={6}>
          <Grid container spacing={2}>
            <Grid size={3}>
              <TextField
                disabled
                label="Last Month Active Users"
                value={selectedForecaster?.last_month_active_users ?? "-"}
                variant="standard"
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  borderRadius: 1,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ForeCasterInfoBase;
